function initOverlay(overlay) {
  const animations = [];
  for (let i = 1; i <= 5; i++) {
    const src = overlay.getAttribute('data-animation-' + i);
    if (src) animations.push(src);
  }
  if (animations.length === 0) return;

  const content = overlay.closest('.product-card__content');
  if (!content) return;

  if (overlay.dataset.overlayInitialized) return;
  overlay.dataset.overlayInitialized = 'true';

  content.addEventListener('mouseenter', () => {
    overlay.src = animations[Math.floor(Math.random() * animations.length)];
    overlay.classList.add('is-visible');
  });
  content.addEventListener('mouseleave', () => {
    overlay.classList.remove('is-visible');
  });
}

function initAllOverlays(root) {
  root.querySelectorAll('.card-gallery__overlay').forEach(initOverlay);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllOverlays(document));
} else {
  initAllOverlays(document);
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) {
        if (node.matches?.('.card-gallery__overlay')) initOverlay(node);
        if (node.querySelectorAll) initAllOverlays(node);
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
